// SPDX-License-Identifier: PROPRIETARY
// SPDX-FileCopyrightText: Copyright The LanceDB Enterprise Authors

/** CSS variables fonts/fonts.ts binds the brand faces to (Aeonik Pro, Fono). */
export const FONT_SANS_VARIABLE = "--font-sans";
export const FONT_DISPLAY_VARIABLE = "--font-display";

const SYSTEM_SANS = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const FONT_SANS_STACK = `var(${FONT_SANS_VARIABLE}), ${SYSTEM_SANS}`;

// Falls back to the text face, not a monospace, if the display face is absent.
export const FONT_DISPLAY_STACK = `var(${FONT_DISPLAY_VARIABLE}), ${FONT_SANS_STACK}`;
